"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawSeparators = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _onResize = require("./onResize");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var $ = _jquery["default"];
var targets = [];

var drawSeparators = function drawSeparators($list, styleId) {
  var lastDim;
  var dim;
  var $this;
  var space;
  var $style;
  var hasWrittenStyle = false;
  var s;
  var bs;
  var re = /(rgb[a]*\(([0-9]{1,3},* *){3}0*\.*[0-9]*\))/;
  var m;
  var color = 'rgb(228, 228, 228)';
  $list.addClass(styleId);
  $list.each(function () {
    $this = $(_this);
    dim = $this.offset();
    dim.width = $this.outerWidth();
    dim.height = $this.outerHeight();

    if (lastDim !== undefined) {
      space = dim.left - (lastDim.left + lastDim.width);

      if (space > 0 && !hasWrittenStyle) {
        $this.attr('data-space', "".concat(space / 2, "px"));
        $style = $("#".concat(styleId));

        if ($style.length) {
          $style.remove();
        }

        s = window.getComputedStyle($list[$list.length - 1], ':after');
        bs = s.getPropertyValue('box-shadow');

        if ((m = re.exec(bs)) !== null) {
          if (m.index === re.lastIndex) {
            re.lastIndex += 1;
          }

          color = m.length ? m[0] : color;
        }

        $('head').append("<style type=\"text/css\" id=\"".concat(styleId, "\">.").concat(styleId, ":not(:first-child)::after { box-shadow: -").concat(space / 2, "px 0px 0px 0px ").concat(color, " !important; }</style>"));
        hasWrittenStyle = true;
      }
    }

    lastDim = dim;
  }); // });
};

var register = function register($list, styleId) {
  targets.push({
    $list: $list,
    styleId: styleId
  });
  drawSeparators($list, styleId);
};

exports.drawSeparators = register;

var execute = function execute() {
  for (var i = 0, len = targets.length; i < len; i += 1) {
    drawSeparators(targets[i].$list, targets[i].styleId);
  }
};

(0, _onResize.onResize)(execute);